import { SET_EDIT_PANEL, CLEAR_EDIT_PANEL, SET_PANEL_COUNT } from "../types";

const initialState = {
    editPanel: null,
    panelCount: 0,
};

const panelReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_EDIT_PANEL:
            return {
                ...state,
                editPanel: action.payload,
            };

        case CLEAR_EDIT_PANEL:
            return {
                ...state,
                editPanel: null,
            };
        case SET_PANEL_COUNT:
            return {
                ...state,
                panelCount: action.payload,
            };
        default:
            return state;
    }
};

export default panelReducer;
